import React from 'react';
import { Button } from 'antd';
import FlareLogoMark from './FlareLogoMark.jsx';

/** Render the compact sidebar as Project navigation only. */
export default function CollapsedSidebarRail({
  background = null,
  logoSlot = null,
  onOperationClick,
  operations = [],
  sidebarHeaderActions = null,
  themeTokens = {},
}) {
  const collapsedButtonStyle = {
    alignItems: 'center',
    borderRadius: 10,
    color: themeTokens.textPrimary,
    display: 'inline-flex',
    height: 34,
    justifyContent: 'center',
    paddingInline: 0,
    width: 34,
  };

  return (
    <div
      className="flare-sidebar-collapsed-rail"
      style={{
        alignItems: 'center',
        background: background ?? themeTokens.sidebarBg,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        height: '100%',
        overflow: 'hidden',
        padding: '10px 0',
        width: '100%',
      }}
    >
      <div style={{ alignItems: 'center', display: 'flex', height: 34, justifyContent: 'center', width: 34 }}>
        {[logoSlot, <FlareLogoMark compact key="default-logo" themeTokens={themeTokens} />].find(Boolean)}
      </div>
      {sidebarHeaderActions}
      <div style={{ background: themeTokens.divider, height: 1, margin: '2px 0', width: 24 }} />
      {operations.map((operation) => (
        <Button
          aria-label={operation.label}
          icon={operation.icon}
          key={operation.key || operation.label}
          onClick={() => onOperationClick?.(operation)}
          style={collapsedButtonStyle}
          title={operation.label}
          type="text"
        />
      ))}
    </div>
  );
}
